
import { parse, serialize } from 'cookie';
import Api from '../../../helpers/Api';
// eslint-disable-next-line import/no-cycle
import { getAvailableProStreams } from '../../aovivoBar/actions/MediaPlayerActions';
import { showSuccess, showError } from '../../../common/A1Alert/A1Alert';

export const SET_AUTH = 'SET_AUTH';
export const setAuth = (jwt) => ({
    type: 'SET_AUTH',
    jwt,
});

export const SET_PROFILE_MODAL = 'SET_PROFILE_MODAL';
export const setProfileModal = (open) => ({
    type: SET_PROFILE_MODAL,
    isOpen: open,
});

export const SET_SUBMITTING_PROFILE = 'SET_SUBMITTING_PROFILE';
const setSubmittingProfile = (submittingType) => ({
    type: SET_SUBMITTING_PROFILE,
    submittingType,
});

export const UNSET_SUBMITTING_PROFILE = 'UNSET_SUBMITTING_PROFILE';
const unsetSubmittingProfile = () => ({
    type: UNSET_SUBMITTING_PROFILE,
});


export const SET_RESENDING = 'SET_RESENDING';
const setResending = () => ({
    type: SET_RESENDING,
});

export const UNSET_RESENDING = 'UNSET_RESENDING';
const unsetResending = () => ({
    type: UNSET_RESENDING,
});

export const SET_EMAIL_RESENT_SUCCESSFULY = 'SET_EMAIL_RESENT_SUCCESSFULY';
const setEmailResentSuccessfuly = () => ({
    type: SET_EMAIL_RESENT_SUCCESSFULY,
});


export const SET_STORE_PROFILE = 'SET_STORE_PROFILE';
const setStoreProfile = (user) => ({
    type: SET_STORE_PROFILE,
    user,
});

export const RESET_STORE_PROFILE = 'RESET_STORE_PROFILE';
const resetStoreProfile = () => ({
    type: RESET_STORE_PROFILE,
});

export const SET_STATES = 'SET_STATES';
const setStates = (states) => ({
    type: SET_STATES,
    states,
});

export const SET_CITIES = 'SET_CITIES';
const setCities = (cities = [], currentStateId = false) => ({
    type: SET_CITIES,
    cities,
    currentStateId,
});

export const SET_PASSWORD_RESET_REQUESTED = 'SET_PASSWORD_RESET_REQUESTED';
const setPasswordResetRequested = (passwordResetRequested) => ({
    type: SET_PASSWORD_RESET_REQUESTED,
    passwordResetRequested,
});

export const SET_PASSWORD_RESETTED = 'SET_PASSWORD_RESETTED';
const setPasswordResetted = (passwordResetted) => ({
    type: SET_PASSWORD_RESETTED,
    passwordResetted,
});

export const SET_BROWSER_HASH = 'SET_BROWSER_HASH';
export const setBrowserHash = (browserHash) => ({
    type: SET_BROWSER_HASH,
    browserHash,
});

export const SET_SESSION_HASH = 'SET_SESSION_HASH';
export const setSessionHash = (sessionHash) => ({
    type: SET_SESSION_HASH,
    sessionHash,
});

export const SET_FIREBASE_POPUP_OPEN = 'SET_FIREBASE_POPUP_OPEN';
export const setFirebasePopupOpen = (firebasePopupOpen) => ({
    type: SET_FIREBASE_POPUP_OPEN,
    firebasePopupOpen,
});

export const SET_PROFILE_INITIALIZED = 'SET_PROFILE_INITIALIZED';
export const initializeProfile = () => ({
    type: SET_PROFILE_INITIALIZED,
});

export const SET_FETCHING_PROFILE = 'SET_FETCHING_PROFILE';
export const setFetchingProfile = (fetchingProfile) => ({
    type: SET_FETCHING_PROFILE,
    fetchingProfile,
});

export const setProfileModalState = (open) => (dispatch) => dispatch(setProfileModal(open));

const _authProblem = (dispatch) => {
    document.cookie = serialize('auth_jwt', '', {
        path: '/',
        sameSite: 'strict',
        expires: new Date('Thu, 01 Jan 1970 00:00:01 GMT'),
    });

    dispatch(setProfileModalState(false));

    dispatch(setAuth(''));

    dispatch(resetStoreProfile());

    return showError('Problema na authenticação. Tente logar de novo ou entre em contato se o problema persiste.');
};

export const registerUser = (data) => (dispatch) => {
    /*
    *data: {name, email, password}
    */

    dispatch(setSubmittingProfile('registerUser'));

    const query = 'api/v1/profile/registerUser';

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            dispatch(unsetSubmittingProfile());

            if (json.status === 'success') {
                // user registered
                return dispatch(setStoreProfile(json.data.user));
                // the email confirmation window/modal should now open, because userId != null and email_confirmed == false
            }

            if (json.message === 'email already registered') {
                return showError('Email já cadastrado no sistema. Por favor, efetue o login.');
            }

            // user not added!
            // check the problem and advise user?
            throw `error from server: ${json.message}`;
        }).catch((error) => {
            dispatch(unsetSubmittingProfile());

            showError('Desculpe, algo deu errado! Tente novamente em alguns minutos.');

            // eslint-disable-next-line no-console
            return console.error('registerUser got error:', error);
        });
};


export const resendConfirmationEmail = (userId, name, email) => (dispatch) => {
    const query = '/api/v1/profile/resendConfirmationEmail';
    const data = {
        name,
        userId,
        email,
    };

    dispatch(setResending());

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            if (json.status === 'success') {
                // Email sucessufuly sent
                const resendingPromises = [
                    dispatch(unsetResending()),
                    dispatch(setEmailResentSuccessfuly()),
                ];

                return Promise.all(resendingPromises);
            }

            // something else went wrong
            dispatch(unsetResending());

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            showError('Desculpe, algo deu errado! Tente novamente em alguns minutos.');

            // eslint-disable-next-line no-console
            return console.error('resendConfirmationEmail got error:', error);
        });
};


export const confirmEmail = (userId, code) => (dispatch) => {
    dispatch(setSubmittingProfile('confirmEmail'));

    const query = 'api/v1/profile/confirmEmail';
    const data = {
        userId,
        code,
    };

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            dispatch(unsetSubmittingProfile());

            if (json.status === 'success') {
                // email verified!
                // after some moments, take the token from the response and log the user in
                setTimeout(() => {
                    dispatch(setAuth(json.data.token));

                    dispatch(getAvailableProStreams());
                }, 2500);

                return dispatch(setStoreProfile(json.data.user));
            }

            if (json.message === 'wrong code') {
                return showError('Código de verificação inválido.');
            }

            if (json.message === 'email already confirmed') {
                return showError('Email já verificado. Por favor, efetue o login.');
            }

            // something else went wrong
            throw `error from server: ${json.message}`;
        }).catch((error) => {
            dispatch(unsetSubmittingProfile());

            showError('Desculpe, algo deu errado! Tente novamente em alguns minutos.');

            // eslint-disable-next-line no-console
            return console.error('confirmEmail got error:', error);
        });
};

export const logout = () => (dispatch) => {
    const query = 'api/v1/profile/logout';
    const data = {};

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            if (json.status === 'success') {
                showSuccess('Sessão encerrada com sucesso!');

                dispatch(setProfileModalState(false));

                return setTimeout(() => {
                    dispatch(setAuth(''));

                    dispatch(resetStoreProfile());
                }, 1000);
            }

            throw `error from server: ${json.message}`;
        // eslint-disable-next-line arrow-body-style
        }).catch((error) => {
            // eslint-disable-next-line no-console
            return console.error('logout got error:', error);
        });
};

export const updateProfile = (user, password = false, passwordChanged = false) => (dispatch, getState) => {
    // @TODO change the following behavior. Ask for the old password when setting a new one
    // if password is false it wont be checked on the api
    // I did this as I don't know how to do it with the facebook logged users
    // and because there is no real need at the moment
    // if this parameter is not false the password will be checked against the one stored in the database before the user is updated

    // if passwordChanged is true, log the user off once the registration was sucessfully updated (to refresh the token)
    dispatch(setSubmittingProfile('updateProfile'));

    const query = 'api/v1/profile/updateProfile';
    const token = getState().profile.jwt;
    const data = {
        user,
        password,
    };

    return Api.progressPost(dispatch, query, data, token)
        .then((json) => {
            dispatch(unsetSubmittingProfile());

            if (json.status === 'success') {
                /**
                * Currently it is not more possible to change the email via the front. The user must get in contact with us.

                if (json.emailChanged) {
                    if the email was changed, log the user off, as he needs to confirm the new email...
                    showSuccess('Cadastro atualizado com sucesso! Confirme o email e efetue o login novamente.');

                    return setTimeout(() => {
                        dispatch(logout());
                    }, 3000);
                }

                */

                if (passwordChanged) {
                    // password was changed, log the user off
                    showSuccess('Sua senha foi atualizada com sucesso! Por favor efetue o login novamente.');

                    return setTimeout(() => {
                        dispatch(logout());
                    }, 3000);
                }

                showSuccess('Dados atualizados com sucesso!');

                return dispatch(setStoreProfile(json.user));

                // return dispatch(getAvailableProStreams()); // This is not necessary for now, but when we have an option for the user become PRO, here might be the right way to fetch the streams
            }

            if (json.message === 'wrong password') {
                // should never happen at the moment, at least as long as password is false
                return showError('Senha atual inválida.');
            }

            /**
             * edit user email is disabled for now (see comment more up)

            if (json.message === 'email already registered') {
                // this email is already existent in the database
                return showError('Email já cadastrado em nossos servidores. Tente outro email.', {
                    timeout: 'none',
                });
            }

            */

            if (json.message === 'cpf already registered') {
                // this email is already existent in the database
                return showError('CPF já cadastrado em nossos servidores. Tente outro CPF.');
            }

            if (json.status === 401) {
                // this most probably means that the jwt is not (more) valid
                return _authProblem(dispatch);
            }

            // something else went wrong
            throw `error from server: ${json.message}`;
        }).catch((error) => {
            dispatch(unsetSubmittingProfile());

            showError('Desculpe, algo deu errado! Tente novamente mais tarde.');

            // eslint-disable-next-line no-console
            return console.error('updateProfile got error:', error);
        });
};

export const getProfile = () => (dispatch, getState) => {
    const query = 'api/v1/profile/getProfile';
    const token = getState().profile.jwt;

    dispatch(setFetchingProfile(true));

    return Api.progressGet(dispatch, query, token)
        .then((json) => {
            if (json.status === 'success') {
                dispatch(setStoreProfile(json.data));

                return dispatch(getAvailableProStreams());
            }

            if (json.status === 401) {
                // this most probably means that the jwt is not (more) valid
                return _authProblem(dispatch);
            }

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            // this might have been a network error..

            // eslint-disable-next-line no-console
            console.error('getProfile got error:', error);

            return showError('Desculpe, algo deu errado! Tente novamente mais tarde.');
        }).finally(() => dispatch(setFetchingProfile(false)));
};

export const getStatesIfNeeded = () => (dispatch, getState) => {
    const states = getState().profile.states;

    if (states.length === 0) {
        const query = 'api/v1/profile/getStates';

        return Api.progressGet(dispatch, query)
            .then((json) => {
                if (json.status === 'success') {
                    return dispatch(setStates(json.data));
                }

                throw `error from server: ${json.message}`;
            // eslint-disable-next-line arrow-body-style
            }).catch((error) => {
                // eslint-disable-next-line no-console
                return console.error('getStatesIfNeeded got error:', error);
            });
    }

    return Promise.resolve(1);
};

export const getCitiesIfNeeded = (stateId) => (dispatch, getState) => {
    const currentStateId = getState().profile.currentStateId;

    if (currentStateId !== stateId) {
        const query = `api/v1/profile/getCitiesByState/${stateId}`;

        // reset the cities first
        dispatch(setCities());

        return Api.progressGet(dispatch, query)
            .then((json) => {
                if (json.status === 'success') {
                    return dispatch(setCities(json.data, stateId));
                }

                throw `error from server: ${json.message}`;
            // eslint-disable-next-line arrow-body-style
            }).catch((error) => {
                // eslint-disable-next-line no-console
                return console.error('getCitiesIfNeeded got error:', error);
            });
    }

    return Promise.resolve(1);
};

export const resetCities = () => (dispatch) => dispatch(setCities());

export const requestPasswordReset = (email) => (dispatch) => {
    dispatch(setSubmittingProfile('requestPasswordReset'));

    const query = 'api/v1/profile/requestPasswordReset';
    const data = {
        email,
    };

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            dispatch(unsetSubmittingProfile());

            if (json.status === 'success') {
                return dispatch(setPasswordResetRequested(true));
            }

            if (json.message === 'user not found') {
                return showError('Email não encontrado');
            }

            throw `error from server: ${json.message}`;
        })
        .catch((error) => {
            dispatch(unsetSubmittingProfile());

            showError('Desculpe, algo deu errado! Tente novamente mais tarde.');

            // eslint-disable-next-line no-console
            return console.error('requestPasswordReset got error: ', error);
        });
};

export const resetPassword = (userId, newPassword, resetToken) => (dispatch) => {
    dispatch(setSubmittingProfile('resetPassword'));

    const query = 'api/v1/profile/resetPassword';
    const data = {
        userId,
        newPassword,
        resetToken,
    };

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            dispatch(unsetSubmittingProfile());

            if (json.status === 'success') {
                return dispatch(setPasswordResetted(true));
            }

            if (json.message === 'invalid data') {
                return showError('Não foi possível alterar a sua senha. O link de recuperação expirou.');
            }

            throw `error from server: ${json.message}`;
        })
        .catch((error) => {
            dispatch(unsetSubmittingProfile());

            showError('Desculpe, algo deu errado! Tente novamente mais tarde.');

            // eslint-disable-next-line no-console
            return console.error('resetPassword got error: ', error);
        });
};

export const login = (email, password) => (dispatch) => {
    dispatch(setSubmittingProfile('login'));

    const query = 'api/v1/profile/login';
    const data = {
        email,
        password,
    };

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            dispatch(unsetSubmittingProfile());

            if (json.status === 'success') {
                const user = json.data.user;

                if (!user.emailConfirmed) {
                    showError('Erro ao tentar efetuar o login. Verifique o e-mail e senha.');

                    return setTimeout(() => {
                        dispatch(setStoreProfile(user));
                    }, 1000);
                }

                showSuccess(`Seja bem-vindo, ${user.name}!`);

                dispatch(setProfileModalState(false));

                return setTimeout(() => {
                    const cookies = parse(document.cookie);

                    dispatch(setAuth(cookies.auth_jwt));

                    dispatch(setStoreProfile(user));

                    return dispatch(getAvailableProStreams());
                }, 1000);
            }

            if (json.message === 'invalid email or password') {
                return showError('Problemas para efetuar o login. Verifique o seu e-mail e a senha.');
            }

            if (json.message === 'user disabled') {
                return showError('Usuário inativo. Por favor, entre em contato conosco.');
            }

            throw `error from server: ${json.message}`;
        })
        .catch((error) => {
            dispatch(unsetSubmittingProfile());

            showError('Desculpe, algo deu errado! Tente novamente em alguns minutos.');

            // eslint-disable-next-line no-console
            return console.error('login got error: ', error);
        });
};

export const registerUserFirebase = (idToken, signInProvider) => (dispatch) => {
    /*
    *idToken [required]: firebase idToken
    */
    dispatch(setSubmittingProfile('registerUser'));

    const query = 'api/v1/profile/registerUserFirebase';
    const data = {
        idToken,
    };

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            dispatch(unsetSubmittingProfile());

            if (json.status === 'success') {
                // user registered
                const user = json.data.user;

                dispatch(setProfileModalState(false));

                if (json.message === 'account linked') {
                    // linked with already existent account
                    showSuccess('Cadastro atualizado com sucesso!');
                } else {
                    // new account created
                    showSuccess('Cadastro criado com sucesso!');
                }

                // wait a moment before setting the jwt because this will refresh the profile modal
                // it is a bit strange but without closing and opening the modal the registration component gets confused, sometimes
                return setTimeout(() => {
                    const cookies = parse(document.cookie);

                    dispatch(setAuth(cookies.auth_jwt));

                    dispatch(setStoreProfile(user));

                    dispatch(getAvailableProStreams());

                    return setTimeout(() => {
                        dispatch(setProfileModalState(true));
                    }, 500);
                }, 500);
            }

            if (json.message === 'no email from provider' || json.message === 'email from provider not verified') {
                return showError(`É necessário ter um email cadastrado e verificado em ${signInProvider} para acessar a página da Antena 1.`);
            }

            if (json.message === 'user disabled') {
                return showError('Já existe um cadastro com esse email no sistema e ele foi desativado. Por favor, entre em contato conosco.');
            }

            if (json.message === 'email and firebaseUid already registered') {
                // eslint-disable-next-line no-use-before-define
                return showError('Esse cadastro já existe no sistema. Clique no botão abaixo para efetuar o login.', { buttons: [{ text: `Logar com ${signInProvider}`, callback: () => dispatch(loginFirebase(idToken, signInProvider)) }] });
            }

            if (json.message === 'firebaseUid already registered with other email') {
                return showError('Esse cadastro já existe no sistema, porém com outro email. Por favor, entre em contato conosco.');
            }

            // Note: The following case should never happen as the error will be thrown in the firebaseAuthComponent and catched and treated there
            if (json.message === 'email already registered with other firebaseUid') {
                return showError('Já existe um cadastro com esse email utilizando um outro meio de autenticação. Por favor, efetue o login com o outro meio de autenticação ou preencha os campos obrigatórios.');
            }

            // user not added! (internal error)
            throw `error from server: ${json.message}`;
        }).catch((error) => {
            dispatch(unsetSubmittingProfile());

            showError('Desculpe, algo deu errado! Tente novamente em alguns minutos ou utilize outra forma de autenticação.');

            // eslint-disable-next-line no-console
            return console.error('registerUserFirebase got error', error);
        });
};

export const loginFirebase = (idToken, signInProvider) => (dispatch) => {
    dispatch(setSubmittingProfile('login'));

    const query = 'api/v1/profile/loginFirebase';
    const data = {
        idToken,
    };

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            dispatch(unsetSubmittingProfile());

            if (json.status === 'success') {
                const user = json.data.user;

                showSuccess('Login realizado com sucesso!');

                dispatch(setProfileModalState(false));

                return setTimeout(() => {
                    const cookies = parse(document.cookie);

                    dispatch(setAuth(cookies.auth_jwt));

                    dispatch(setStoreProfile(user));

                    return dispatch(getAvailableProStreams());
                }, 1000);
            }

            if (json.message === 'user not found by firebaseUid or firebaseEmail') {
                return dispatch(registerUserFirebase(idToken, signInProvider))
            }

            if (json.message === 'user disabled') {
                return showError('Login não efetuado! Usuário desabilitado. Por favor entre em contato conosco.');
            }

            if (json.message === 'user found by email but without firebaseUid') {
                return showError(`Login não efetuado! Já existe uma conta com esse email no sistema. Para habilitar o login através de ${signInProvider}, clique no botão abaixo.`,
                    { buttons: [{ text: 'Linkar cadastro agora', callback: () => dispatch(registerUserFirebase(idToken, signInProvider)) }] });
            }

            // Note: The following case should never happen as the error will be thrown in the firebaseAuthComponent and catched and treated there
            if (json.message === 'user found by email but with different firebaseUid') {
                return showError('Login não efetuado! Esse email é atrelado a um outro meio de autenticação. Por favor, útilize o outro meio de autenticação ou email e senha para se logar.');
            }

            throw `error from server: ${json.message}`;
        })
        .catch((error) => {
            dispatch(unsetSubmittingProfile());

            showError('Desculpe, algo deu errado! Tente novamente em alguns minutos ou utilize outra forma de autenticação.');

            // eslint-disable-next-line no-console
            return console.error('loginFirebase got error:', error);
        });
};

export const setProfileInitialized = () => (dispatch) => dispatch(setStoreProfile({}));

/**
 * Delete the users profile
 *
 * This function deletes the profile of the currently logged in user.
 * It fails if the user has an active PRO subscription or if something did not work on the server.
 *
 */
export const deleteProfile = () => (dispatch, getState) => {
    const url = '/api/v1/profile/deleteProfile';
    const token = getState().profile.jwt;
    const userId = getState().profile.user.userId;
    const email = getState().profile.user.email;

    const data = {
        userId,
        email,
    };

    dispatch(setSubmittingProfile('deleteProfile'));

    return Api.progressPost(dispatch, url, data, token)
        .then((json) => {
            if (json.status !== 'success') {
                if (json.message === 'active pro subscription') {
                    return showError('Essa conta possui uma assinatura ativa. Entre em contato conosco para apagar o seu cadastro.');
                }

                throw `error from server: ${json.message}`;
            }

            dispatch(setProfileModalState(false));

            showSuccess('Cadastro excluído. Para realizar o login, é necessário realizar o cadastro novamente.', {
                duration: Infinity,
            });

            return setTimeout(() => {
                dispatch(setAuth(''));

                dispatch(resetStoreProfile());
            }, 1000);
        })
        .catch((err) => {
            // eslint-disable-next-line no-console
            console.error('got error when deleting profile:', err);

            return showError('Ocorreu um erro ao tentar apagar sua conta. Tente novamente ou entre em contato conosco.');
        })
        .finally(() => dispatch(unsetSubmittingProfile()));
};
